import { Injectable } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import { PlayerStats } from '@app/models/player-stats.model';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as amplitude from 'amplitude-js';
import { AuthenticationService } from '@app/core';

@Injectable()
export class PlayerStatsService {
  private _storageKey: string = 'edg-live-stats';
  public stats: PlayerStats = new PlayerStats();

  private _enabledSubject: Subject<boolean>;
  onEnabled$: Observable<boolean>;

  public _enabled: boolean = false;

  private currentGame: string = null;

  constructor(private auth: AuthenticationService) {
    const value = localStorage.getItem(this._storageKey);
    this._enabled = value === 'true';

    this._enabledSubject = new BehaviorSubject(this._enabled);
    this.onEnabled$ = this._enabledSubject.asObservable();
  }

  public setCurrentGame(game: string) {
    this.currentGame = game;
  }

  public toggleStats(): void {
    this._enabled = !this._enabled;
    this._enabledSubject.next(this._enabled);
    localStorage.setItem(this._storageKey, this._enabled.toString());
  }

  public resetStats(): void {
    this.stats = new PlayerStats();
  }

  public isEnabled(): boolean {
    return this._enabled;
  }

  public addProfit(profit: number): void {
    if (this.currentGame && this.auth.isMainServer()) {
      const identity = new amplitude.Identify()
        .add(`Profit - ${this.currentGame}`, profit)
        .add(`Profit - Total`, profit);
      amplitude.getInstance().identify(identity);
    }
    this.stats.profit += Number(profit);
  }

  public addWagerer(wagered: number = 1): void {
    if (this.currentGame && this.auth.isMainServer()) {
      const identity = new amplitude.Identify()
        .add(`Wagered - ${this.currentGame}`, wagered)
        .add(`Wagered - Total`, wagered);
      amplitude.getInstance().identify(identity);
    }
    this.stats.wagered += Number(wagered);
  }

  public addWin(count: number = 1): void {
    if (this.currentGame && this.auth.isMainServer()) {
      const identity = new amplitude.Identify().add(`Bets - ${this.currentGame}`, count).add(`Bets - Total`, count);
      amplitude.getInstance().identify(identity);
    }
    this.stats.wins += Number(count);
  }

  public addLoss(count: number = 1): void {
    if (this.currentGame && this.auth.isMainServer()) {
      const identity = new amplitude.Identify().add(`Bets - ${this.currentGame}`, count).add(`Bets - Total`, count);
      amplitude.getInstance().identify(identity);
    }
    this.stats.losses += Number(count);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/player-stats.service.ts